import { render, staticRenderFns } from "./relationTest.vue?vue&type=template&id=084d5fa8&scoped=true&"
import script from "./relationTest.vue?vue&type=script&lang=js&"
export * from "./relationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d5fa8",
  null
  
)

export default component.exports